/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveFormSelectViewProps } from './eve-form-select';

export default (props: IEveFormSelectViewProps) => {
    const {
        config: { friendlyName, values },
        registeredField
    } = props;

    let optionIndex: number = 0;
    return (
        <div className='form__dropdown'>
            <label className={'eve-form__label'}>{friendlyName}</label>
            {values ? (
                <select className={'eve-form__select'} onChange={props.handleChange} value={registeredField.value}>
                    {values.map(value => {
                        if (value.isDefault) {
                            return (
                                <option key={optionIndex++} value={value.value !== '' ? value.value : value.displayValue} selected>
                                    {value.displayValue}
                                </option>
                            );
                        } else {
                            return (
                                <option key={optionIndex++} value={value.value !== '' ? value.value : value.displayValue}>
                                    {value.displayValue}
                                </option>
                            );
                        }
                    })}
                </select>
            ) : (
                <></>
            )}
            {props.registeredField.errors.map((err, idx) => (
                <div className={'eve-form__error'} key={`${idx}-${err}`}>
                    {err}
                </div>
            ))}
        </div>
    );
};
